import React from 'react';
import { Button, Card } from '@vwfs-bronson/bronson-react';
import { useAnalyticsActionTracker } from '@cp-shared-19/frontend-ui';
import { BrokerDetails, DashboardMarketingCard } from 'cpnl-common';
import { currentBrand } from 'config';
import { getLinkWithTraciParams } from './utils';
import { getCurrentStage } from 'utils';
import { useTranslation } from 'react-i18next';

export type DashboardMarketingCardUiProps = {
    dashboardMarketingCard?: DashboardMarketingCard;
    brokerDetails?: BrokerDetails;
};

const decodeSoftHyphen = (value?: string): string => (value ? value.replace(/&shy;/g, '\u00ad') : '');

export const DashboardMarketingCardUi: React.FC<DashboardMarketingCardUiProps> = ({
    dashboardMarketingCard,
    brokerDetails,
}) => {
    const { onAction } = useAnalyticsActionTracker('onLearnMore');
    const { t } = useTranslation('dashboard');

    if (!dashboardMarketingCard) return null;

    const { carInsurance, brokerDetails: brokerDetailsCms } = dashboardMarketingCard;
    const currentStage = getCurrentStage();

    const handleClick = (): void => {
        const link = getLinkWithTraciParams(
            carInsurance.buttonUrl[currentStage],
            currentBrand,
            carInsurance.buttonLabel,
        );
        window.open(link, '_blank');
        onAction(carInsurance.title);
    };

    return (
        <>
            {brokerDetails && (
                <Card className="u-mb u-text-left" element="article" testid="brokerDetailsCard">
                    {(currentBrand === 'seat' || currentBrand === 'vwcv' || currentBrand === 'vw') && (
                        <>
                            <h5 className={'u-heading-alternative u-hide@l u-mb'}>
                                {decodeSoftHyphen(brokerDetailsCms.title)}
                            </h5>
                            <h6 className={'u-heading-alternative u-hide@l-up u-mb'}>
                                {decodeSoftHyphen(brokerDetailsCms.title)}
                            </h6>
                            <h5 className={'u-heading-alternative u-hide@l u-mb'}>{brokerDetails.companyName}</h5>
                            <h6 className={'u-heading-alternative u-hide@l-up u-mb'}>{brokerDetails.companyName}</h6>
                        </>
                    )}
                    {currentBrand !== 'seat' && currentBrand !== 'vwcv' && currentBrand !== 'vw' && (
                        <>
                            <h3 className={'u-heading-alternative u-hide@l u-mb'}>
                                {decodeSoftHyphen(brokerDetailsCms.title)}
                            </h3>
                            <h4 className={'u-heading-alternative u-hide@l-up u-mb'}>
                                {decodeSoftHyphen(brokerDetailsCms.title)}
                            </h4>
                            <h3 className={'u-heading-alternative u-hide@l u-mb'}>{brokerDetails.companyName}</h3>
                            <h4 className={'u-heading-alternative u-hide@l-up u-mb'}>{brokerDetails.companyName}</h4>
                        </>
                    )}
                    <p className="u-mb-none">{`${brokerDetails.streetName} ${brokerDetails.streetNumber}`}</p>
                    <p>{`${brokerDetails.zipCode} ${brokerDetails.city}`}</p>
                    <div className="o-button-container  o-button-container--vertical">
                        <Button
                            type="button"
                            element="a"
                            href={`tel:${brokerDetails.mainPhone}`}
                            link
                            title={t('marketingCard.phoneButtonTitle')}
                            ariaLabel={t('marketingCard.phoneButtonAria')}
                        >
                            {brokerDetails.mainPhone}
                        </Button>
                        {brokerDetails.mobilePhone && (
                            <>
                                <Button
                                    type="button"
                                    element="a"
                                    href={`tel:${brokerDetails.mobilePhone}`}
                                    link
                                    title={t('marketingCard.phoneButtonTitle')}
                                    ariaLabel={t('marketingCard.phoneButtonAria')}
                                >
                                    {brokerDetails.mobilePhone}
                                </Button>
                            </>
                        )}
                        <Button type="" element="a" href={`mailto:${brokerDetails.email}`} link>
                            {brokerDetails.email}
                        </Button>
                        <Button
                            element="a"
                            href={`https://${brokerDetails.website}`}
                            target="_blank"
                            link
                            title={t('marketingCard.externalLinkTitle')}
                            ariaLabel={t('marketingCard.externalLinkAria')}
                        >
                            {brokerDetails.website}
                        </Button>
                    </div>
                </Card>
            )}
            {carInsurance.title && (
                <Card
                    element="article"
                    imageSrc={carInsurance.imageUrl || ''}
                    footer
                    buttons={[
                        <Button
                            key={'buttonKey'}
                            link={true}
                            icon="semantic-forward"
                            iconReversed
                            small
                            onClick={handleClick}
                            title={t('marketingCard.insuranceTitle')}
                            ariaLabel={t('marketingCard.insuranceAria')}
                        >
                            {carInsurance.buttonLabel}
                        </Button>,
                    ]}
                >
                    <h4 className={'u-heading-alternative u-hide@m u-mb'}>{carInsurance.title}</h4>
                    <h3 className={'u-heading-alternative u-hide@m-up u-mb'}>{carInsurance.title}</h3>
                    {carInsurance.text}
                </Card>
            )}
        </>
    );
};
